import React from "react";
import RollOverSummaryContainer from "../../../containers/Employee/RollOverSummaryContainer";

const RollOverPlanDetails = (props) => {
  return <RollOverSummaryContainer {...props} />;
};

export default RollOverPlanDetails;
